import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { AvatarComponent } from '../components/avatar/avatar.component';
import { UserAvatarComponent } from '../components/user-avatar/user-avatar.component';
import { PrimengModule } from './primeng.module';
import { NewProductComponent } from '../components/new-product/new-product.component';
import { InputPreviewComponent } from 'src/app/pages/admin-services/input-preview/input-preview.component';
import { ProviderProfileTagComponent } from 'src/app/company/my-orders/provider-profile-tag/provider-profile-tag.component';
import { CompanyLogoNameComponent } from 'src/app/global-components/company-logo-name/company-logo-name.component';
import { OrderChatPanelComponent } from '../components/order-chat-panel/order-chat-panel.component';

@NgModule({
  declarations: [
    AvatarComponent,
    UserAvatarComponent,
    NewProductComponent,
    InputPreviewComponent,
    ProviderProfileTagComponent,
    CompanyLogoNameComponent,
    OrderChatPanelComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    LeafletModule,
    PrimengModule,
    ReactiveFormsModule,
    RouterModule,
  ],
  exports: [
    FormsModule,
    LeafletModule,
    AvatarComponent,
    UserAvatarComponent,
    NewProductComponent,
    InputPreviewComponent,
    ProviderProfileTagComponent,
    CompanyLogoNameComponent,
    ReactiveFormsModule,
    OrderChatPanelComponent,
  ],
})
export class SharedModule {}
